// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1gsG9","info":"Note_info__udL_L","note":"Note_note__10AX_","actions":"Note_actions__3z5-G"};